import { useTenantContext } from '../tenant-context';

export const useFirstActivationDateMs = (): number | null => {
	const tenantContext = useTenantContext();
	return tenantContext && tenantContext.firstActivationDateMs != null
		? tenantContext.firstActivationDateMs
		: null;
};
